
  import search from "@/mixins/search";

  import ModalRoomTypes from "./ModalRoomTypes";
  import ModalPriceRange from "./ModalPriceRange";
  import ModalFilters from "./ModalFilters";

  export default {
    name: "PropertiesListHeader",
    components: {
      ModalFilters,
      ModalPriceRange,
      ModalRoomTypes
    },
    mixins: [
      search
    ],
    data() {
      return {
        modalRoomTypes: false,
        modalPriceRange: false,
        modalFilters: false,
        isShowMap: false
      }
    },
    beforeMount() {
      if (this.network.default_search === this.$const('default_search', 'GRID_MAP')) {
        this.isShowMap = true;
      }
    },
    methods: {
      checkDates(data) {
        return this.$moment(data).isValid();
      },
      toggleMap() {
        this.isShowMap = !this.isShowMap;
        this.$emit('toggle-map', this.isShowMap);
      },
    },
    computed: {
      areDatesSelected() {
        return this.checkDates(this.searchFiltersFormatted.from_date) &&
          this.checkDates(this.searchFiltersFormatted.to_date) &&
          this.checkDates(this.searchFiltersFormatted.year);
      },
      headerStyle() {
        let image =
          "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80";

        if (!!this.network?.images?.length) {
          image = this.network.images[0].sizes_full_path.high;
        }

        return `
          background-image: url(${image});
          background-position: center center;
          background-repeat: no-repeat;
          background-attachment: scroll;
          background-size: cover;
          background-color: rgba(55, 55, 55, 0.5)`;
      },
    }
  }
